import { render, staticRenderFns } from "./CreateDocuments.vue?vue&type=template&id=d659b6a6&"
import script from "./CreateDocuments.vue?vue&type=script&lang=js&"
export * from "./CreateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports